import React, { useState, useEffect, useRef } from "react";
import { withRedux } from "helpers";
import Store from "./Store";
import StoreSettings from "./StoreSettings";

import Modal from "@material-ui/core/Modal";

import styled, { css } from "react-emotion";

function EditStore(props) {
  const {
    activeApp: { id: appId },
    activeTemplate: { id: templateId },
    actions: { getStoreItems, updateActiveEditor, refreshActiveEditor },
  } = props;
  const firstDealId = null || 0;

  const {
    store,
    activeEditor,
    activeApp: { id, view },
    cards,
  } = props;

  useEffect(() => {
    updateActiveEditor(firstDealId);

    getStoreItems(appId, templateId);
  }, [templateId]);

  useEffect(() => {
    return () => {
      refreshActiveEditor();
    };
  }, []);

  const getStorePages = () => {
    // console.dir(templates.filter((t) => t.type === "store"));
    return templates.filter((t) => t.type === "store");
  };

  const toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = props;

    updateActiveEditor(idx);
  };

  const activeStoreItem = store[activeEditor];

  // console.log("active store item:");
  // console.dir(activeStoreItem);

  let isNewStoreItem = false;
  if (activeStoreItem) {
    isNewStoreItem = activeStoreItem.id === "newStoreItem";
  }

  const templates = view.templates;
  const hasPunchcardPage =
    templates.find((t) => t.type === "punchCard") === undefined ? false : true;
  return (
    <div>
      <StoreSettings />
      <Modal
        open={activeStoreItem}
        disableAutoFocus={true}
        disableBackdropClick={isNewStoreItem}
        onClose={() => toggleActiveEditor(null)}
        style={{
          top: "1%",
          width: "97%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Store
          appId={id}
          templateId={templateId}
          {...props.actions}
          storeItem={activeStoreItem}
          hasPunchcardPage={hasPunchcardPage}
          punchcards={cards}
          getStorePages={getStorePages}
        />
      </Modal>
    </div>
  );
}

export default withRedux(EditStore);
